import {announce} from '@github-ui/aria-live'
import {useMutation, useQueryClient} from '@github-ui/react-query'

import {LABELS} from '../constants'
import {useSavedViewEndpoints} from '../contexts/SavedViewEndpointsContext'
import type {CreateSavedViewResponse, UpdateSavedViewVariables} from '../types'
import {
  primeSavedViewCaches,
  type SavedViewMutationOptions,
  sendSavedViewMutationJson,
} from '../utils/saved-view-mutations'

export function useUpdateSavedViewMutation({owner, repo}: SavedViewMutationOptions) {
  const queryClient = useQueryClient()
  const {basePath} = useSavedViewEndpoints(owner, repo)

  return useMutation<CreateSavedViewResponse, Error, UpdateSavedViewVariables>({
    mutationFn: ({id, ...body}) =>
      sendSavedViewMutationJson<CreateSavedViewResponse>(
        `${basePath}/${encodeURIComponent(id)}.json`,
        {method: 'PUT', body},
        LABELS.views.updateError,
      ),
    onSuccess: ({savedView}) => primeSavedViewCaches({queryClient, owner, repo}, savedView),
    onError: () => announce(LABELS.views.updateError, {assertive: true}),
  })
}
